import { ListBox } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo } from 'react';
import type { EditBlockStore } from '../../store';
import { EditValueType } from '../../types';
import { EditActionValueItem } from './EditActionValueItem';

export interface EditActionValueDropdownStringProps {
	store: EditBlockStore;
	actionSearchKey: string;
	onItemClick: (value: string, shouldClose: boolean, label?: string) => void;
	placeholder?: string;
}

export const EditActionValueDropdownString = observer(
	({
		store,
		actionSearchKey,
		onItemClick,
		placeholder,
	}: EditActionValueDropdownStringProps) => {
		const editAction = store.editActions.get(actionSearchKey)!;

		const onSelect = useCallback(
			(v: string) => (close: boolean) => {
				onItemClick(v, close, v);
			},
			[onItemClick]
		);

		const onDeselect = useCallback(
			(close: boolean) => {
				onItemClick('', close, '');
			},
			[onItemClick]
		);

		const items = useMemo(() => {
			const result = [];

			if (editAction.stringValue) {
				result.push(editAction.stringValue);
			}

			return result;
		}, [editAction.stringValue]);

		return (
			<ListBox.ItemsDropdown
				search={{
					onChange: editAction.setStringValue,
					value: editAction.stringValue,
					placeholder: placeholder ?? 'Type',
				}}
				items={items}
				renderItem={(item, getProps) => (
					<EditActionValueItem
						key={`edit-action-value-${item}`}
						item={{ label: item as string, value: item as string }}
						editValueType={EditValueType.MULTIPLE}
						selected={editAction.editAction.value === item}
						onClick={
							editAction.editAction.value === item
								? onDeselect
								: onSelect(item as string)
						}
						getProps={getProps}
					/>
				)}
			/>
		);
	}
);
